module.exports = __webpack_public_path__ + "static/media/b-user.9f21432c.png";